const validation_ready = (callback) => {
   if (document.readyState != "loading") callback();
   else document.addEventListener("DOMContentLoaded", callback);
};


validation_ready(() => {
   const phoneInput = document.querySelector('input[type="tel"]');

   if (phoneInput) {
      phoneInput.addEventListener("input", function () {
         this.value = this.value.replace(/[^0-9+\-()\s]/g, "");
      });
   }
});
